// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Input */

.wrap-input{
    width: 100%;
    position: relative;
    border-bottom: 2px solid #ADADAD;
}

.wrap-input .input{
    width: 100%;
    height: 3em;
    display: block;
    font-size: 1.4em;
    color: #000000;
    line-height: 1.2em;
    border: none;
    background-color: transparent;
    outline: 0;
    padding-top: 0.3em;
    padding-left: 0.5em;
}

.wrap-input .password-toggle-icon{
    position: absolute;
    top: 1.25em;
    right: 0.6em;
    cursor: pointer
}

.focus-input{
    position: absolute;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    color: #ADADAD;
}

.focus-input::before{
    content: "";
    display: block;
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 0;
    height: 2px;

    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
    -moz-transition: all 0.4s;
    background: linear-gradient(to left, var(--high-orange-sensedia), var(--high-orange-sensedia));
}

.focus-input::after{
    font-size: 1.4em;
    color: #999999;
    line-height: 1.2em;

    content: attr(data-placeholder);

    display: block;
    width: 100%;
    position: absolute;
    top: 14px;
    left: 0px;
    padding-left: 5px;

    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
    -moz-transition: all 0.4s;
}

.input:focus + .focus-input::after, .has-value + .focus-input::after{
    top: -14px;
}

.input:focus + .focus-input::before{
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/authentication/input/style.css"],"names":[],"mappings":"AAAA,UAAU;;AAEV;IACI,WAAW;IACX,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,UAAU;IACV,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ;AACJ;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,oBAAoB;IACpB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;;IAEX,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;IAKzB,8FAA8F;AAClG;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;;IAElB,+BAA+B;;IAE/B,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;;IAEjB,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf","sourcesContent":["/* Input */\n\n.wrap-input{\n    width: 100%;\n    position: relative;\n    border-bottom: 2px solid #ADADAD;\n}\n\n.wrap-input .input{\n    width: 100%;\n    height: 3em;\n    display: block;\n    font-size: 1.4em;\n    color: #000000;\n    line-height: 1.2em;\n    border: none;\n    background-color: transparent;\n    outline: 0;\n    padding-top: 0.3em;\n    padding-left: 0.5em;\n}\n\n.wrap-input .password-toggle-icon{\n    position: absolute;\n    top: 1.25em;\n    right: 0.6em;\n    cursor: pointer\n}\n\n.focus-input{\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    pointer-events: none;\n    color: #ADADAD;\n}\n\n.focus-input::before{\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    width: 0;\n    height: 2px;\n\n    -webkit-transition: all 0.4s;\n    -o-transition: all 0.4s;\n    -moz-transition: all 0.4s;\n\n    background: -webkit-linear-gradient(to left, var(--high-orange-sensedia), var(--high-orange-sensedia));\n    background: -o-linear-gradient(to left, var(--high-orange-sensedia), var(--high-orange-sensedia));\n    background: -moz-linear-gradient(to left, var(--high-orange-sensedia), var(--high-orange-sensedia));\n    background: linear-gradient(to left, var(--high-orange-sensedia), var(--high-orange-sensedia));\n}\n\n.focus-input::after{\n    font-size: 1.4em;\n    color: #999999;\n    line-height: 1.2em;\n\n    content: attr(data-placeholder);\n\n    display: block;\n    width: 100%;\n    position: absolute;\n    top: 14px;\n    left: 0px;\n    padding-left: 5px;\n\n    -webkit-transition: all 0.4s;\n    -o-transition: all 0.4s;\n    -moz-transition: all 0.4s;\n}\n\n.input:focus + .focus-input::after, .has-value + .focus-input::after{\n    top: -14px;\n}\n\n.input:focus + .focus-input::before{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
